<template>
  <div>
    <video ref="videoPlayer" controls preload="auto" class="video-js vjs-16-9"></video>
  </div>
</template>

<script>
import videojs from 'video.js'
import 'videojs-contrib-hls'

export default {
  name: 'VideoPlayer',
  props: {
    options: {
      type: Object,
      default() {
        return {}
      }
    },
    src: {
      type: Object,
      default() {
        return null
      }
    }
  },
  data() {
    return {
      player: null
    }
  },
  mounted() {
    this.player = videojs(
      this.$refs.videoPlayer,
      this.options,
      function onPlayerReady() {}
    )
  },
  beforeDestroy() {
    if (this.player) {
      this.player.dispose()
    }
  }
}
</script>
<style>
.vjs-big-play-button {
  visibility: hidden !important;
}
/*
.vjs-tech {
  pointer-events: none;
}
.vjs-modal-dialog {
  visibility: hidden !important;
}
video::-webkit-media-controls-overlay-play-button {
  display: none;
} */
button:not(:disabled),
[type='button']:not(:disabled),
[type='reset']:not(:disabled),
[type='submit']:not(:disabled) {
  /* visibility: hidden !important; */
}
/* .vjs-modal-dialog-content {
  visibility: hidden !important;
} */
</style>
